/*
 * @description: 接口配置文件
 */

const auth = {
  LOGIN: '/auth/login', // 登录
  LOGIN_OUT: '/auth/logout', // 退出

}


// 应用管理接口
const app = {
  ADD_APP: '/application/add',  // 添加app
  APP_UPDATE: '/application/update',  // 编辑APP
  APP_LIST: '/application/list',  // 查看APP详情
  APP_DETAILS: '/application/',  // 查询APP详情
  APP_DELETE: '/application/'  // 删除项目
}

//告警管理
const alarm = {
  ALARM_LIST: '/alarm/list',   // 告警列表
  ALARM_DETAILS: '/alarm/',   // 告警列表
  ALL_APP: '/alarm/list',
  DEL_ALARM: '/alarm/deleteAlarm',  // 删除
  EXPORT_ALARM: '/alarm/export',  // 导出告警信息
  ALARM_PUSH:'/alarm/queryAlarmPushRecord/',//推送记录
  ALARM_AGAIN_PUSH:'/alarm/alarmPushRecordAgain/',//再次推送

  PUSH_ALARM_DEVICE: '/alarm/getDetectTaskAlarmList', //管理端告警列表
  PUSH_ALARM_SEND: '/alarm/DetectTaskAlarmPushRecordAgain', //推理任务再次推送告警记录
  PUSH_ALARM_DETAIL: '/alarm/getDetectTaskAlarmInfo', //获取推理任务详细信息
}

// 告警管理2.0
const alarmPlus = {
  COLLECT_POINT_GROUP: '/apply/collectionAlarmManage/listCollectionLocationGroup', // 采集数据-查询点位分组
  COLLECT_POINT:'/apply/collectionAlarmManage/listCollectionLocation',             // 采集数据-查询点位
  COLLECT_ALGO: '/apply/collectionAlarmManage/listCollectionAlgorithm',            // 采集数据-关联算法
  COLLECT_PUSH_NUM: '/apply/collectionAlarmManage/collectionAlarmTotalNum',        // 采集数据-推送数量
  COLLECT_ALARM_TREND: '/apply/collectionAlarmManage/collectionAlarmNumDaily',     // 采集数据-告警趋势
  COLLECT_ALARM_RANKING: '/apply/collectionAlarmManage/CollectionAlarmTopNum',     // 采集数据-告警排名
  COLLECT_ALARM_LIST: '/apply/collectionAlarmManage/listCollectionAlarm',          // 采集数据-告警列表
  COLLECT_ALARM_LIST_BY_GROUP: '/apply/collectionAlarmManage/listCollectionAlarmByGroup', // 采集数据-按点位分组查询 告警列表
  COLLECT_ALARM_DETAIL: '/apply/collectionAlarmManage/CollectionAlarmDetail',      // 采集数据-告警详情
  COLLECT_ALARM_PUSH_PLUS: '/apply/pushBusinessSystem/pushCollectTaskAlarm',       // 采集数据-告警推送
  COLLECT_ALARM_DELETE: '/apply/collectionAlarmManage/deleteCollectionAlarm',      // 采集数据-告警删除
  
  VIDEO_POINT_GROUP: '/apply/videoStreamAlarmManage/listVideoStreamLocationGroup', // 实时视频流-查询点位分组
  VIDEO_POINT:'/apply/videoStreamAlarmManage/listVideoStreamLocation',             // 实时视频流-查询点位
  VIDEO_ALGO: '/apply/videoStreamAlarmManage/listVideoStreamAlgorithm',            // 实时视频流-关联算法
  VIDEO_PUSH_NUM: '/apply/videoStreamAlarmManage/collectionAlarmTotalNum',        // 实时视频流-推送数量
  VIDEO_ALARM_TREND: '/apply/videoStreamAlarmManage/collectionAlarmNumDaily',     // 实时视频流-告警趋势
  VIDEO_ALARM_RANKING: '/apply/videoStreamAlarmManage/CollectionAlarmTopNum',     // 实时视频流-告警排名
  VIDEO_ALARM_LIST: '/apply/videoStreamAlarmManage/listCollectionAlarm',          // 实时视频流-告警列表
  VIDEO_ALARM_LIST_BY_GROUP: '/apply/videoStreamAlarmManage/listCollectionAlarmByGroup', // 实时视频流-按点位分组查询 告警列表
  VIDEO_ALARM_DETAIL: '/apply/videoStreamAlarmManage/videoStreamAlarmDetail',      // 实时视频流-告警详情
  VIDEO_ALARM_PUSH_PLUS: '/apply/pushBusinessSystem/pushVideoStreamTaskAlarm',         // 实时视频流-告警推送
  VIDEO_ALARM_DELETE: '/apply/videoStreamAlarmManage/deleteVideoStreamAlarm',      // 实时视频流-告警删除
  
  IMAGE_POINT_GROUP: '/apply/fileSetAlarmManage/listFileSetGroup',        // 图片文件-查询文件集分组
  IMAGE_POINT:'/apply/fileSetAlarmManage/listFileSet',                    // 图片文件-查询文件集
  IMAGE_ALGO: '/apply/fileSetAlarmManage/listFileSetAlgorithm',           // 图片文件-关联算法
  IMAGE_PUSH_NUM: '/apply/fileSetAlarmManage/queryAlarmPushSummary',      // 图片文件-推送数量
  IMAGE_ALARM_TREND: '/apply/fileSetAlarmManage/queryAlarmDateSummary',   // 图片文件-告警趋势
  IMAGE_ALARM_RANKING: '/apply/fileSetAlarmManage/fileSetAlarmTopNum',    // 图片文件-告警排名
  IMAGE_ALARM_LIST: '/apply/fileSetAlarmManage/listFileSetAlarm',         // 图片文件-告警列表
  IMAGE_ALARM_LIST_BY_GROUP: '/apply/fileSetAlarmManage/listFileSetAlarmByGroup', // 图片文件-按点位分组查询 告警列表
  IMAGE_ALARM_DETAIL: '/apply/fileSetAlarmManage/fileSetAlarmDetail',     // 图片文件-告警详情
  IMAGE_ALARM_PUSH_PLUS: '/apply/pushBusinessSystem/pushPictureTaskAlarm',// 图片文件-告警推送
  IMAGE_ALARM_DELETE: '/apply/fileSetAlarmManage/deleteFileSetAlarm',     // 图片文件-告警删除
  IMAGE_FILE_LIST: '/apply/fileSetAlarmManage/queryFileSetFileResultList', // 图片文件-列表
  IMAGE_FILE_DETAIL: '/apply/fileSetAlarmManage/queryImageDetail', // 图片文件-详情
  
  VIDEO_FILE_POINT:'/apply/videoFileTaskManage/list',                    // 视频文件-查询文件集
  // VIDEO_FILE_LIST: '/apply/videoFileTaskManageAlarm/list', // 视频文件-列表
  VIDEO_FILE_LIST: '/apply/videoFileTaskAlarm/list', // 视频文件-列表
  VIDEO_FILE_DETAIL: '/apply/videoFileTaskManageAlarm/getVideoFileTaskManageAlarmDetail', // 视频文件-详情
  GET_VIDEO_FILE_INFO: '/apply/videoFileTaskManageAlarm/getVideoFileResultFrameList', // 视频文件 - 获取结果视频信息
}

const task = {
  TASK_LIST_IMAGE: '/pictureTask/list',  // 图片任务列表
  TASK_LIST_VIDEO: '/videoFileTask/list',  // 视频文件任务列表
  TASK_LIST_VIDEO_STREAM: '/videoStreamTask/list',  // 视频流任务列表

  TASK_ADD_VIDEO_STREAM:'/videoStreamTask/create',//新增视频流任务
  TASK_ADD_VIDEO:'/videoFileTask/create',//新增视频任务
  TASK_ADD_IMAGE:'/pictureTask/create',//新增图片任务

  TASK_DETAIL_VIDEO_STREAM:'/videoStreamTask/',//视频流任务详情
  TASK_DETAIL_VIDEO:'/videoFileTask/',//视频任务详情
  TASK_DETAIL_IMAGE:'/pictureTask/',//图片任务详情

  TASK_DELETE_VIDEO_STREAM:'/videoStreamTask/delete',//视频流任务详情
  TASK_DELETE_VIDEO:'/videoFileTask/delete',//视频任务详情
  TASK_DELETE_IMAGE:'/pictureTask/delete',//图片任务详情

  TASK_EDIT_VIDEO_STREAM:'/videoStreamTask/update',//视频流任务 编辑
  TASK_EDIT_VIDEO:'/videoFileTask/update',//视频任务 编辑
  TASK_EDIT_IMAGE:'/pictureTask/update',//图片任务 编辑

  TASK_STOP_VIDEO:'/videoFileTask/stop',//视频任务 停止任务
  TASK_STOP_VIDEO_STREAM:'/videoStreamTask/stop', //停止任务
  TASK_START_VIDEO_STREAM:'/videoStreamTask/start', //开始任务
  TASK_OPEN_PREVIEW:'/videoStreamTask/openPreview',//带算法预览-开启
  TASK_CLOSE_PREVIEW:'/videoStreamTask/closePreview',//带算法预览-关闭
  TASK_HEARTBEAT:'/videoStreamTask/heartbeat',//心跳检测

  TASK_PREVIEW:'/task/preview',//不带算法的预览 （另外一个服务）

  TASK_CHECK_FILE:'/videoFileTask/checkSharding', //校验分片
  TASK_FILE_STATUS:'/videoFileTask/queryMultipartUploadStatus',//查询分片上传状态
  TASK_UPFILE:'/videoFileTask/uploadShardedFile',//上传分片文件

  TASK_SUMMARY: '/videoStreamTask/queryTaskNum' , // 任务数据汇总

  TASK_STREAM_SUMMARY: '/videoStreamTask/queryTaskNum'  ,// 视频流任务数据汇总
  TASK_VIDEO_FILE_SUMMARY: '/videoFileTask/queryTaskNum'  ,// 视频流任务数据汇总
  TASK_IMAGE_SUMMARY: '/pictureTask/queryTaskNum'  ,// 视频流任务数据汇总


  QUERY_VIDEOFILE_LIST: "/videoFileTask/queryVideoFileResultFrameList" ,//获取视频文件的告警信息

  RESTART_VIDEOFILE_TASK:"/videoFileTask/start" //重启视频文件任务
}

const algorithm = {
  ALGORITHM_CLASSIFY: '/algorithmClassify/list', // 算法分类列表
  ALGORITHM_LIST:'/algorithm/list',//算法列表
  ALGORITHM_DETAILS:'/algorithm/',   //算法详情
  ALGORITHM_DETAILS_FILTER:'/algorithm/queryUsableAlgorithmlist',   //算法列表-过滤后的
  MAX_DROP_FRAME: '/algorithm/queryAlgorithmMaxDropFrameNum'  // 算法最大跳帧数
}

//上传文件
const upload = {
  UPLOAD_FILE:'/videoStreamTask/upload' //上传
}

// 智能采集
const collect = {
  GET_LABEL_LIST: '/apply/sampleFile/querySampleFileLabellist', // 查询可用标签列表
  GET_SAMPLE_DETAIL: '/apply/sampleFile/',  // 查询样本图片详情
  SAVE_MARK_DATA: '/apply/sampleFile/createMarkFile', // 保存标注信息
}

const landing = {
  GET_AALARM_DETAAIL: '/apply/pictureTaskAlarm/',   // 查询告警详情 中台、业务系统接口一致
  UPDATE_ALARM: '/apply/pictureTaskAlarm/updateAlarm',  // 更新告警状态为 未解决、已解决  中台、业务系统接口一致
  ON_UPDATE_STATUS: '/apply/alarm/updateDealStatusByEdgeDeviceAlarmId',  // 更新状态为处理中  中台、业务系统接口一致
}

const collectAlarms = {
  HOUSE_TREE: '/apply/deviceMenu/queryDeviceMenu',  // 更新告警状态
  GET_COLLECT_ALARM_LIST: '/apply/pictureTaskAlarm/list',   // 查询告警列表
  GET_COLLECT_ALARM_DETAIL: '/apply/pictureTaskAlarm/queryAlarmPeriodPicture'   // 查询告警列表
}

const system = {
  GET_USER: '/user/getInfo', // 获取登录用户信息
  //系统管理--用户管理
  USER_LIST: '/user/list', // 获取账号列表
  UPSERT_USER: '/user',  // 新增/编辑用户
  GET_USER_ROLES: '/user/', // 查询所有角色
  DEL_USER: '/user/', // 删除系统账户
  RESET_PWD: '/user/resetPwd', // 重置密码
  CHANGE_PWD: '/user/profile/updatePwd', // 修改密码'
  UPDATE_STATE: '/user/changeStatus', // 修改账号状态

  //系统管理--角色权限
  ROLE_LIST: '/role/list', // 分页查询角色列表
  OBTAIN_MENU: '/menu/treeselect', // 获取菜单列表
  SELECTED_MENU: '/menu/roleMenuTreeselect/', // 根据角色ID查询菜单下拉树结构
  ROLE_DETAIL: '/role/', // 角色详情
  UPDATE_ROLES: '/role/', // 添加/编辑角色
  DEL_ROLE: '/role/',  // 删除角色

  //系统管理--菜单管理
  GET_MENU: '/menu/list',
  UPDATE_MENU: '/menu', // 编辑菜单
  DEL_MENU: '/menu/', // 删除菜单

  // 系统管理-日志
  GET_OPERATE: '/operlog/list',  // 操作日志
  DEL_OPERATE: '/operlog/',  // 删除操作日志
  CLEAN_OPERATE: '/operlog/clean',  // 清空操作日志

  GET_LOGIN: '/logininfor/list',  // 登录日志
  DEL_LOGIN: '/logininfor/',  // 删除登录日志
  CLEAN_LOGIN: '/logininfor/clean',  // 清空登录日志
  EXPORT_OPERRECORD: '/operlog/export',  // 导出操作日志
  EXPORT_LOGINRECORD: '/logininfor/export',  // 导出操作日志

  // 系统管理-数据字典
  GET_DICT_LIST: '/dict/data/list', // 查询字典数据列表
  GET_DICT_DETAIL: '/dict/data/', // 查询字典数据详情
  GET_DICT_TYPE: '/dict/data/type/',  // 根据字典类型查询字典数据信息
  ADD_DICT: '/dict/data',  // 新增字典数据
  UPDATE_DICT: '/dict/data',  // 修改字典数据
  DEL_DICT: '/dict/data/',  // 删除字典数据

  GET_DICTTYPE_LIST: '/dict/type/list',  // 查询字典类型列表
  GET_DICTTYPE_DETAIL: '/dict/type/',  // 查询字典类型详细
  ADD_DICTTYPE: '/dict/type',  // 新增字典类型
  UPDATE_DICTTYPE: '/dict/type',  // 修改字典类型
  DEL_DICTTYPE: '/dict/type/',  // 删除字典类型
  REFRESH_DICTTYPE: '/dict/type/refreshCache',  // 刷新字典缓存
  OPTION_DICTTYPE: '/dict/type/optionselect',  // 获取字典选择框列表
};

const upgrade = {
    // 系统管理-采集管理
    GET_CURRENT_VERSION_INFO: '/apply/preDeviceVersion/queryCurrentVersionInfo', // 查询当前版本信息
    CHECK_NEW_VERSION: '/apply/preDeviceVersion/checkNewVersion', // 检查版本更新
    UPGRADE_DEVICE_LIST: '/apply/preDeviceVersion/upgradeDeviceList', // 升级设备列表
    GET_HISTORY_VERSION_LIST: '/apply/preDeviceVersion/queryHistoryVersionList', // 查询历史版本列表
}
const evAlarm = {
  EV_ALARM_LIST: '/apply/pictureTaskAlarm/queryPictureAlarm',  // 电动车告警推送列表
  EV_ALARM_TASK_LIST: '/apply/edgeDeviceTask/list',
  EV_ALARM_EXAMINE: '/apply/pictureTaskAlarm/updateAuditAlarmFile',  // 告警数据推送
  EV_ALARM_PUSH_BUSINESS: '/apply/pushBusinessSystem/pushAlarm',  // 推送应用系统
  EV_ALARM_TASK_COUNT: '/apply/pictureTaskAlarm/queryTaskAlarmNum',
  PUSH_ALARM_LIST: '/apply/pictureTaskAlarm/queryDetectTaskPictureAlarm',  // 查询推理告警列表
  PUSH_ALARM_NUM: '/apply/pictureTaskAlarm/queryDetectTaskAlarmNum', //查询告警数量
  DATA_STATICS_DETAIL: '/apply/summaryRoadDiseases/list', // 统计数据详情
}
//设备管理
const device = {
  ADD_DEVICE: '/apply/preDeviceInfo/add',//新增设备
  DEL_DEVICE: '/apply/preDeviceInfo/delete',//删除设备
  UPDATE_DEVICE: '/apply/preDeviceInfo/edit',//更新设备
  GET_DEVICE_LIST: '/apply/preDeviceInfo/list',//获取设备列表
  GET_DEVICE_INFO: '/apply/preDeviceInfo/queryById',//获取设备详情
  GET_DEVICE_STATUS_NUM: '/apply/preDeviceInfo/queryDeviceStatusSummary',//查询设备状态统计

  ADD_DEVICE_GROUP: '/apply/preDeviceGroup/add',  // 新增设备分组
  DEL_DEVICE_GROUP: '/apply/preDeviceGroup/delete', // 删除设备分组
  UPDATE_DEVICE_GROUP: '/apply/preDeviceGroup/edit',  // 更新设备分组
  GET_DEVICE_GROUP_LIST: '/apply/preDeviceGroup/list', // 设备总览-获取设备分组列表
  GET_COLLECT_DEVICE_GROUP_LIST: '/apply/deviceCollectionLog/getDeviceGroup', // 获取设备分组列表
  GET_COLLECT_LIST: '/apply/deviceCollectionLog/getDeviceByParam', // 查询设备采集列表
  GET_COLLECT_LOG_BASE: '/apply/deviceCollectionLog/queryTaskBaseInfo', // 查询某设备的采集日志列表-基本信息
  GET_COLLECT_LOG_LIST: '/apply/deviceCollectionLog/queryTaskCollectLogList', // 查询某设备的采集日志列表-列表信息
  DOWNLOAD_COLLECT_LOG: '/apply/deviceCollectionLog/downloadLog', // 下载某设备的采集日志
  GET_DEVICE_ERROR_LIST: '/apply/preDeviceCheckErrorLog/queryDeviceErrorLogList', // 获取设备异常列表信息
  GET_DEVICE_ERROR_NUM: '/apply/preDeviceCheckErrorLog/queryEventTypeSummary', // 获取设备异常数量
  GET_DEVICE_ERROR_GROUP: '/apply/preDeviceCheckErrorLog/queryErrorDeviceGroupList', // 获取异常设备分组
  GET_ERROR_DEVICE_LIST: '/apply/preDeviceCheckErrorLog/queryErrorDeviceListByRequest', // 获取异常设备
  GET_DEVICE_ERROR_DATE: '/apply/preDeviceCheckErrorLog/queryErrorDateList', // 获取异常设备日期
}

const edgeTask = {
  GET_EDGE_DEVICE_LIST: '/apply/preDeviceTask/queryDeviceList',  // 查询设备列表
  GET_EDGE_TASK_SUMMARY: '/apply/preDeviceTask/queryTaskStatusSummary',  // 查询任务状态统计
  GET_EDGE_TASK_LIST: '/apply/preDeviceTask/list',  // 获取边缘任务列表
  UPDATE_EDGE_TASK_STATUS: '/apply/preDeviceTask/updateRunStatus',  // 更新任务状态
  ADD_EDGE_TASK: '/apply/preDeviceTask/add',  // 新增边缘任务
  EDIT_EDGE_TASK: '/apply/preDeviceTask/edit',  // 修改边缘任务
  DEL_EDGE_TASK: '/apply/preDeviceTask/delete',  // 删除边缘任务
  GET_EDGE_TASK_IMAGE: '/apply/preDeviceTask/catchImage',  // 抓图
  GET_EDGE_TASK_DETAILS: '/apply/preDeviceTask/queryById',  // 查询任务详情
  GET_EDGE_TASK_IMAGE_LIST: '/apply/preDeviceTask/queryTaskImageList', // 查询边缘采集任务图片列表
  DEL_EDGE_TASK_IMAGE: '/apply/preDeviceTask/batchDeleteImage',  // 删除边缘任务
}

// 云端推理任务
const cloudTask = {
  ADD_CLOUD_TASK: '/apply/detectTask/create', // 新增云端推理任务
  DEL_CLOUD_TASK: '/apply/detectTask/delete', // 删除云端推理任务
  EDIT_CLOUD_TASK: '/apply/detectTask/update', // 编辑云端推理任务
  GET_CLOUD_TASK_LIST: '/apply/detectTask/list', // 查询云端推理任务列表
  GET_CLOUD_TASK_NUM: '/apply/detectTask/queryTaskNum', // 查询云端推理任务数量
  GET_REASONING_IMG_LIST: '/apply/detectTask/queryTaskAlarmPicture', // 查询推理结果图片列表
  DEL_REASONING_IMG: '', // 删除推理结果图片
  CHANGE_TASK_STATUS: '/apply/detectTask/enable', // 改变某个任务的启停状态
  GET_INFER_SERVICE_LIST: '/apply/pictureIllationAlgorithm/queryUsableAlgorithmlist', // 查询推理服务列表
  GET_REASONING_IMG_DETAIL: '/apply/detectTask/getDetectTaskAlarmInfo', // 查询图片详情
  GET_PRE_CHECK_ALGORITHM_LIST: '/apply/preDeviceInfo/queryAllAlgorithmList', // 查询预检算法列表
  GET_APPLICATION_AREA_LIST: '/apply/preDeviceInfo/queryDeviceApplicationList', // 查询应用场景列表
  GET_DETAIL_INFO: '/apply/detectTask/getDetailInfo',//获取推理任务详细信息

}

const terminal = {
  TERMINAL_APPLICATION_LIST: '/apply/preDeviceInfo/queryDeviceApplicationList',  // 查询终端应用列表
  TERMINAL_ALGORITHM_LIST: '/apply/preDeviceInfo/queryDeviceAlgorithmList',  // 查询终端预置算法列表
}


const dataSourceManagement = {
  /*采集数据源点位组相关*/
  GET_POINT_GROUP_LIST: '/apply/preLocationGroup/list',  // 查询点位组列表
  ADD_POINT_GROUP: '/apply/preLocationGroup/add',  // 添加点位组
  EDIT_POINT_GROUP: '/apply/preLocationGroup/edit',  // 编辑点位组
  DEL_POINT_GROUP: '/apply/preLocationGroup/delete',  // 删除点位组

  /*视频流数据源点位组相关*/
    GET_POINT_GROUP_LIST_STREAM: '/apply/videoStreamLocationGroup/list',  // 查询点位组列表
    ADD_POINT_GROUP_STREAM: '/apply/videoStreamLocationGroup/create',  // 添加点位组
    EDIT_POINT_GROUP_STREAM: '/apply/videoStreamLocationGroup/update',  // 编辑点位组
    DEL_POINT_GROUP_STREAM: '/apply/videoStreamLocationGroup/delete',  // 删除点位组
    GET_POINT_GROUP_LIST_STREAMAll: '/apply/videoStreamLocationGroup/queryAllList',  // 查询点位组列表-不分页
    
    POST_STREAM_SUMMARY : '/apply/videoStreamLocation/summary' , // 统计视频流
    POST_STREAM_SHOT : '/apply/videoStreamLocation/snapshot' , // 快照
    GET_STREAM_SHOT : '/apply/videoStreamLocation/getSnapshot' , // 获取快照
    
    /*图片数据源点位组相关*/
      GET_POINT_GROUP_LIST_IMAGE: '/apply/fileSetGroup/list',  // 查询点位组列表
      GET_POINT_GROUP_LIST_IMAGEAll: '/apply/fileSetGroup/queryAllList',  // 查询点位组列表
      ADD_POINT_GROUP_IMAGE: '/apply/fileSetGroup/create',  // 添加点位组
      EDIT_POINT_GROUP_IMAGE: '/apply/fileSetGroup/update',  // 编辑点位组
      DEL_POINT_GROUP_IMAGE: '/apply/fileSetGroup/delete',  // 删除点位组

      UPLOAD_IMAGE_FILE : '/apply/fileSetChunkFile/postFileUpload' , // zip上传图片文件
      GET_IMAGE_FILE_STATUS : '/apply/fileSetChunkFile/getFileUpload' , // zip检查分片文件上传状态
      POST_IMAGE_FILE_MERGE : '/apply/fileSetChunkFile/merge' , // zip合并文件
      QUERY_UNZIPERRORLIST : '/apply/fileSet/queryUnzipErrorList' , //查看解压错误图片文件

      UPLOAD_IMAGE_FILE_PATCH : '/apply/fileSetFile/uploadImages' , // 批量上传图片文件
      PATCH_DELETE_IMAGE_FILE : '/apply/fileSetFile/batchDelete' , // 批量删除
      POST_IMAGE_FILE_DELETE : '/apply/fileSetFile/delete' , // 删除
      POST_GETUUID:"/apply/algorithmChunkFile/getUUID", //获取uuid


      POST_IMAGE_ON : '/apply/fileSet/updateStatus' , // 启用停用
      POST_IMAGE_SUMMARY : '/apply/fileSet/summary' , // 统计文件集数量
      POST_IMAGE_FILE_DETAIL : '/apply/fileSet/detail' , // 文件详情
      POST_IMAGE_FILE_LIST : '/apply/fileSetFile/list' , // 图片文件列表

    /*视频文件数据源点位组相关*/
    GET_POINT_GROUP_LIST_VIDEO: '/apply/videoFileSetGroup/list',  // 查询点位组列表
    ADD_POINT_GROUP_VIDEO: '/apply/videoFileSetGroup/create',  // 添加点位组
    EDIT_POINT_GROUP_VIDEO: '/apply/videoFileSetGroup/update',  // 编辑点位组
    DEL_POINT_GROUP_VIDEO: '/apply/videoFileSetGroup/delete',  // 删除点位组


  GET_POINT_DEVICE_LIST_AND_SUMMARY: '/apply/preLocationTask/queryDeviceList', // 查询点位组下设备列表和统计信息

  /*点位相关*/
  ADD_POINT: '/apply/preLocation/add',  // 新增点位
  EDIT_POINT: '/apply/preLocation/edit',  // 修改点位
  DEL_POINT: '/apply/preLocation/delete',  // 删除点位
  GET_POINT_LIST: '/apply/preLocation/list',  // 查询点位列表
  GET_COLLECT_RELATION_TASK_LIST: '/apply/preLocationTask/queryCollectRelationDetectTaskList', // 查询采集关联推理任务列表
  GET_FILE_RELATION_TASK_LIST: '/apply/fileSet/queryFileSetRelationDetectTaskList', // 查询文件集关联推理任务列表
  GET_POINT_COLLECT_SUMMARY: '/apply/preLocation/queryTaskStatusSummary',  // 查询点位任务状态统计

  /*采集数据列表*/
  ADD_POINT_COLLECT_TASK: '/apply/preLocationTask/add',  // 新增点位采集任务
  EDIT_POINT_COLLECT_TASK: '/apply/preLocationTask/edit',  // 编辑点位采集任务
  GET_POINT_TASK_IMAGE: '/apply/preLocationTask/catchImage',  // 捕获图片
  UPDATE_POINT_TASK_STATUS: '/apply/preLocationTask/updateRunStatus',  // 更新点位任务状态
  GET_POINT_TASK_DETAIL: '/apply/preLocationTask/queryById',  // 查询点位任务详情
  DEL_POINT_TASK: '/apply/preLocationTask/delete',  // 删除点位任务
  GET_POINT_TASK_IMAGE_LIST: '/apply/preLocationTask/queryTaskImageList', // 查询点位任务图片列表
  DEL_POINT_TASK_IMAGE: '/apply/preLocationTask/batchDeleteImage', // 删除点位任务图片

  EDIT_POINT_VIDEO_TASK:  '/apply/videoFileSet/update',//编辑视频文件集
  ADD_POINT_VIDEO_TASK: '/apply/videoFileSet/create',//新增视频文件集
  GET_POINT_VIDEO_TASK_LIST:'/apply/videoFileSet/list',//查询视频文件集列表
  DEL_POINT_VIDEO_TASK: '/apply/videoFileSet/delete',//删除视频文件集
  GET_POINT_VIDEO_TASK_NUM: '/apply/videoFileSet/summary',//统计视频文件集
  STOP_POINT_VIDEO_TASK: '/apply/videoFileSet/updateStatus',//启停视频文件
  UPLOAD_POINT_VIDEO_TASK: '/apply/videoFileSet/uploadVideoFile',//上传视频文件
  GET_POING_VIDEO_LIST: '/apply/videoFileSetFile/list',//视频文件列表
  GET_POINT_VIDEO_TASK_ERROR_LIST: '',//查询视频文件集失败列表
  GET_POINT_VIDEO_TASK_RELATE: '',//查询视频文件集关联的推理任务列表

  //视频流点位列表
  POST_STREAM_POINT_TASK_ADD: '/apply/videoStreamLocation/create' ,// 新增视频流点位 
  POST_STREAM_POINT_TASK_DELETE: '/apply/videoStreamLocation/delete' ,// 删除视频流点位 
  POST_STREAM_POINT_TASK_QUERYPAGE: '/apply/videoStreamLocation/list', // 查询视频流点位 
  POST_STREAM_POINT_TASK_EDIT: '/apply/videoStreamLocation/update', // 编辑视频流点位 
 

  //图片文件点位列表
  POST_IMAGE_POINT_TASK_ADD: '/apply/fileSet/create' ,// 新增视频流点位 
  POST_IMAGE_POINT_TASK_DELETE: '/apply/fileSet/delete' ,// 删除视频流点位 
  POST_IMAGE_POINT_TASK_QUERYPAGE: '/apply/fileSet/list', // 查询视频流点位 
  POST_IMAGE_POINT_TASK_EDIT: '/apply/fileSet/update' // 编辑视频流点位 

}

//任务管理
const taskManagement = {
  GET_TASK_LIST: '/apply/detectTaskManage/queryDetectTaskManage', // 查询任务列表
  GET_TASK_DETAIL: '/apply/detectTaskManage/getDetailInfo', // 查询任务详情
  GET_TASK_IMAGE_LIST: '/apply/detectTaskManage/queryTaskAlarmPicture', // 查询任务图片列表
  GET_TASK_STATUS_NUM: '/apply/detectTaskManage/queryDetectTaskManageNum', // 查询任务不同状态数量
  GET_TASK_INFER_SERVICE_LIST: '/apply/detectTaskManage/queryDetectTaskAlgorithm', // 查询推理服务列表
  GET_NEW_IMAGE: '/apply/detectTaskManage/queryCatchImagePath',//重新获取图片
  ADD_DETECT_DATA: '/apply/detectTaskManage/create',//新增配置数据
  EDIT_DETECT_DATA: '/apply/detectTaskManage/update',//编辑配置数据
  DEL_DETECT_DATA: '/apply/detectTaskManage/delete', // 删除云端推理任务
  CHANGE_TASK_ENABLE_STATUS: '/apply/detectTaskManage/enable', // 改变某个任务的启停状态
  GET_RELATE_COLLECT_DATA:'/apply/detectTaskManage/queryCollectTaskDetail',//查询推理任务关联的采集任务信息
  GET_TASK_REASONING_IMG_DETAIL: '/apply/detectTaskManage/getDetectTaskAlarmInfo', // 查询图片列表的图片详情



  GET_STREAM_TASK_LIST:'/apply/videoStreamTaskManage/list',//查询视频流任务列表
  ADD_STREAM_TASK:'/apply/videoStreamTaskManage/create',//新增视频流任务
  DELETE_STREAM_TASK:'/apply/videoStreamTaskManage/delete',//删除视频流任务
  START_STREAM_TASK:'/apply/videoStreamTaskManage/start',//开启视频流任务
  STOP_STREAM_TASK:'/apply/videoStreamTaskManage/stop',//停止视频流任务
  EDIT_STREAM_TASK:'/apply/videoStreamTaskManage/update',//编辑视频流任务
  GET_TASK_AlGORITHM:'/apply/videoStreamTaskManage/queryVideoStreamTaskAlgorithm',//根据点位查询推理算法列表
  GET_STREAM_TASK_DETAIL:'/apply/videoStreamTaskManage/queryById',//查询视频流任务详情
  GET_NEW_STREAM:"/apply/videoStreamTaskManage/videoStreamTaskScreenshot",//视频流截图
  GET_STREAM_TASK_NUM:'/apply/videoStreamTaskManage/queryVideoStreamTaskNum',//查询视频流任务数量
  DEL_STREAM_TASK_LIST: "/apply/videoStreamTaskManage/batchDelete",//批量删除视频流点位下的任务
  DEL_COLLECT_TASK_LIST: "/apply/detectTaskManage/batchDelete",//批量删除采集任务下的任务
  
}

// 场景管理
const sceneManager = {
  GET_SCENE_AREA:'/apply/algorithm/scenes-detection', //根据ID查询检测区域
  GET_SECNE_PARAMS: '/apply/algorithm/scene-params/scene', //获取场景参数
  GET_SCENE_DETAIL: '/apply/algorithm/scene', // 查询场景详情
}


//告警审核
const alarmReview = {
  GET_ALARM_LOCATION: '/apply/userGroupPointPermission/queryAllLocation', // 查询所有点位
  GET_PROJECT_AND_DATASOURCE: '/apply/userDataSourcePermission/queryAllProjectAndDataSource', // 获取所有项目数据源
  GET_ALARM_GROUP: '/apply/userGroupPointPermission/queryAllGroup', // 查询所有组
  POST_AUDIT_DATAPOINT:'/apply/audit/dataPoint/add'
}
//  接口加上指定代理前缀
for (var k in system) {
  system[k] = `/system${system[k]}`
}

for (var k in app) {
  app[k] = `/apply${app[k]}`
}

for (let key in alarm) {
  alarm[key] = `/apply${alarm[key]}`
}

for (let key in task) {
  task[key] = `/apply${task[key]}`
}

for (let key in algorithm) {
  algorithm[key] = `/apply${algorithm[key]}`
}

for (let key in upload) {
  upload[key] = `/apply${upload[key]}`
}

export default {
  ...sceneManager,
  ...auth,
  ...system,
  ...upgrade,
  ...alarm,
  ...alarmPlus,
  ...app,
  ...task,
  ...algorithm,
  ...upload,
  ...collect,
  ...landing,
  ...collectAlarms,
  ...evAlarm,
  ...device,
  ...edgeTask,
  ...cloudTask,
  ...terminal,
  ...dataSourceManagement,
  ...taskManagement,
  ...alarmReview,
}
